import axios from "axios";
class ApiSettings {
    static async GetEmailNotifications(session_uuid) {
        try {
            const result = await axios.get("/api/settings/get-email-notifications", {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            throw new Error("Error get email notifications");
        }
    }
    static async GetEmailNotificationByUUID(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/settings/get-email-notifications-by", {
                uuid: uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.data;
        }
        catch (e) {
            return undefined;
        }
    }
    static async CreateEmailNotification(session_uuid, publish, template_id, template_name, topic_name, send_to, bcc, file) {
        try {
            const result = await axios.post("/api/settings/create-email-notifications", {
                publish: publish,
                template_id: template_id,
                template_name: template_name,
                topic_name: topic_name,
                send_to: send_to,
                bcc: bcc,
                file: file,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            console.error(e);
            if ("response" in e && "data" in e.response && "response" in e.response.data) {
                return e.response.data.response;
            }
        }
        return undefined;
    }
    static async UpdateEmailNotificationPublish(publish, session_uuid, uuid) {
        try {
            const result = await axios.post("/api/settings/change-email-notifications-publish", {
                uuid: uuid,
                publish: publish,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
    static async UpdateEmailNotification(template_name, topic_name, send_to, bcc, file, publish, session_uuid, uuid) {
        try {
            const result = await axios.post("/api/settings/change-email-notifications-info", {
                template_name: template_name,
                topic_name: topic_name,
                send_to: send_to,
                bcc: bcc,
                file: file,
                publish: publish,
                uuid: uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            throw new Error("Error");
        }
    }
    static async DeleteEmailNotification(session_uuid, uuid) {
        try {
            const result = await axios.post("/api/settings/delete-email-notifications", {
                uuid: uuid,
            }, {
                headers: {
                    "x-tenant": "null",
                    "x-session-token": session_uuid,
                },
            });
            return result.data.response;
        }
        catch (e) {
            return undefined;
        }
    }
}
export default ApiSettings;
